import { convertDate } from "@_common/date-helpers";
import { sanitizeInput } from "@_common/dompurify";
import InputField from "@_common/InputRuleFeild";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { CopyToClipboard } from "@_common/text-helpers";
import {
  createComplianceCertificateConfig,
  getComplianceCertificateConfig,
  getComplianceCertificateConfigKeys,
  updateComplianceCertificateConfig,
} from "@services/email-template.service";
import { getValue } from "@utils/lodash";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

function CertificateConfig(props: any) {
  const { showUpdatePopup, setShowUpdatePopup, hideExtraAnnexures } = props;

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.showUpdatePopup) {
      getData();
      getKeys();
    }
  }, [props.showUpdatePopup]);

  // ----- UseState-----
  const [isLoading, setIsLoading] = React.useState(true);
  const [editId, setEditId] = useState();

  const [configRequest, setConfigRequest] = useState({
    description: "",
    annexure_1: "",
    annexure_1_no_data: "",
    enabled_annexure_1: false,
    annexure_2: "",
    annexure_2_no_data: "",
    enabled_annexure_2: false,
    annexure_3: "",
    annexure_3_no_data: "",
    enabled_annexure_3: false,
    annexure_4: "",
    annexure_4_no_data: "",
    enabled_annexure_4: false,
    annexure_5: "",
    annexure_5_no_data: "",
    enabled_annexure_5: false,
    legislation_Rule_Custom_Date: false,
    show_all_time_legislation_rule: false,
    contract_date: null,
  });

  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setConfigRequest({
      ...configRequest,
      [name]: value,
    });
  };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    try {
      let payload = {
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        // page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
        is_summary_config: hideExtraAnnexures ? "true" : "false",
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await getComplianceCertificateConfig(queryRequest);
      if (resp) {
        // Handle both array response and object-with-data response
        const responseData = getValue(resp, "data", resp); // Fallback to resp if no data property

        if (Array.isArray(responseData) && responseData.length > 0) {
          const config = responseData[0];
          setConfigRequest({
            description: atob(getValue(config, "description", "")),
            annexure_1: getValue(config, "annexure_1", ""),
            enabled_annexure_1: getValue(config, "enable_annexure_1", false),
            annexure_1_no_data: getValue(config, "annexure_1_no_data", ""),
            annexure_2: getValue(config, "annexure_2", ""),
            annexure_2_no_data: getValue(config, "annexure_2_no_data", ""),
            enabled_annexure_2: getValue(config, "enable_annexure_2", false),
            annexure_3: getValue(config, "annexure_3", ""),
            annexure_3_no_data: getValue(config, "annexure_3_no_data", ""),
            enabled_annexure_3: getValue(config, "enable_annexure_3", false),
            annexure_4: getValue(config, "annexure_4", ""),
            annexure_4_no_data: getValue(config, "annexure_4_no_data", ""),
            enabled_annexure_4: getValue(config, "enable_annexure_4", false),
            annexure_5: getValue(config, "annexure_5", ""),
            annexure_5_no_data: getValue(config, "annexure_5_no_data", ""),
            enabled_annexure_5: getValue(config, "enable_annexure_5", false),
            legislation_Rule_Custom_Date: getValue(
              config,
              "show_certificate_settings",
              false,
            ),
            show_all_time_legislation_rule: getValue(
              config,
              "show_all_time_legislation_rule",
              false,
            ),
            contract_date: getValue(config, "contract_date", null),
          });

          // Set edit ID if exists
          const configId = getValue(config, "id", null);
          if (configId) {
            setEditId(configId);
          }
        }

        // setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [keysInfo, setKeys] = useState({});

  const getKeys = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    try {
      let payload = {
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        // page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
        is_summary_config: hideExtraAnnexures ? "true" : "false",
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await getComplianceCertificateConfigKeys(queryRequest);
      if (resp) {
        setKeys(getValue(resp, `data`, {}));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [submitLoading, setSubmitLoading] = useState();

  const handleSubmit = async () => {
    if (
      getValue(configRequest, "show_all_time_legislation_rule", false) &&
      !getValue(configRequest, "contract_date", null)
    ) {
      toast.error("Contract Date is required");
      return;
    }
    try {
      let payload = {
        // description: getValue(configRequest, `description`, ""),
        description: btoa(getValue(configRequest, `description`, "")),
        annexure_1: getValue(configRequest, `annexure_1`, ""),
        annexure_1_no_data: getValue(configRequest, `annexure_1_no_data`, ""),
        annexure_2: getValue(configRequest, `annexure_2`, ""),
        annexure_2_no_data: getValue(configRequest, `annexure_2_no_data`, ""),
        annexure_3: getValue(configRequest, `annexure_3`, ""),
        annexure_3_no_data: getValue(configRequest, `annexure_3_no_data`, ""),
        annexure_4: getValue(configRequest, `annexure_4`, ""),
        annexure_5: getValue(configRequest, `annexure_5`, ""),
        annexure_4_no_data: getValue(configRequest, `annexure_4_no_data`, ""),
        annexure_5_no_data: getValue(configRequest, `annexure_5_no_data`, ""),
        enable_annexure_1: getValue(configRequest, `enabled_annexure_1`, false),
        enable_annexure_2: getValue(configRequest, `enabled_annexure_2`, false),
        enable_annexure_3: getValue(configRequest, `enabled_annexure_3`, false),
        enable_annexure_4: getValue(configRequest, `enabled_annexure_4`, false),
        enable_annexure_5: getValue(configRequest, `enabled_annexure_5`, false),
        show_certificate_settings: getValue(
          configRequest,
          "legislation_Rule_Custom_Date",
          false,
        ),
        show_all_time_legislation_rule: getValue(
          configRequest,
          "show_all_time_legislation_rule",
          false,
        ),
        contract_date: getValue(configRequest, "contract_date", null),
        is_summary_config: hideExtraAnnexures ? true : false,
      };
      setIsLoading(true);
      let resp;
      if (editId) {
        resp = await updateComplianceCertificateConfig(editId, payload);
      } else {
        resp = await createComplianceCertificateConfig(payload);
      }

      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setIsLoading(false);
        setConfigRequest({
          description: "",
          annexure_1: "",
          annexure_1_no_data: "",
          enabled_annexure_1: false,
          annexure_2: "",
          annexure_2_no_data: "",
          enabled_annexure_2: false,
          annexure_3: "",
          annexure_3_no_data: "",
          enabled_annexure_3: false,
          annexure_4: "",
          annexure_4_no_data: "",
          enabled_annexure_4: false,
          annexure_5: "",
          annexure_5_no_data: "",
          enabled_annexure_5: false,
          legislation_Rule_Custom_Date: false,
          show_all_time_legislation_rule: false,
          contract_date: null,
        });
        setShowUpdatePopup(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className={`compelte-task-wrapper ${
          showUpdatePopup ? "compelte-task-wrapper--active" : ""
        }`}
      >
        <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
          <h6 className="compelte-task-wrapper__title">
            Configure Certificate
          </h6>
          <img
            src="/images/close-white.svg"
            className="img-fluid navigation-bar-wrapper__close-btn"
            onClick={() => {
              setShowUpdatePopup(false);
            }}
            alt=""
          />
        </div>

        {/* <div className="compelte-task-wrapper__body d-flex h-100"></div> */}
        <div className="d-flex max-height-mail-template email-template-wrapper">
          <div className="user-details-wrapper m-0 email-template-editable-content-holder w-100">
            <div className="email-template-editable-content">
              <div className="mb-3">
                <div className="d-flex justify-content-between gap-2">
                  <div>
                    <label className="checkpoint-active-details__label">
                      Description
                    </label>
                  </div>

                  <div className="d-flex certificate-config-keys keys-container align-items-center">
                    <label htmlFor="" className="mb-0 me-3">
                      Placeholders
                    </label>
                    <div
                      className="d-flex align-items-center"
                      style={{ flexWrap: "wrap" }}
                    >
                      {getValue(keysInfo, `keys`, []).map((item: any) => {
                        return (
                          <div
                            className="key-title-container"
                            onClick={() => CopyToClipboard(`<%= ${item} %>`)}
                          >
                            <p className="key-title">{item}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <InputField
                  inputType="TEXTAREA"
                  placeholder="Enter Description"
                  className="form-control w-100"
                  name="description"
                  id="description"
                  value={getValue(configRequest, `description`, "")}
                  onChange={(e: any) => handleChangeText(e)}
                  label="Description"
                />
              </div>

              <div className="mb-3 ">
                <div className="d-flex gap-2">
                  <div className="input-50">
                    <label className="checkpoint-active-details__label">
                      Annexure 1
                    </label>
                    <InputField
                      inputType="TEXTAREA"
                      placeholder="Enter Annexure 1"
                      className="form-control w-100"
                      name="annexure_1"
                      id="annexure_1"
                      value={getValue(configRequest, `annexure_1`, "")}
                      onChange={(e: any) => handleChangeText(e)}
                      label="Annexure 1"
                    />
                  </div>

                  <div className="input-50">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="checkpoint-active-details__label mb-0">
                        Annexure 1 If no Data
                      </label>

                      {!hideExtraAnnexures && (
                        <div className="d-flex align-items-center">
                          <p className="header_text__black mb-0 me-2">
                            Enable Annexure 1
                          </p>
                          <div className="choicelist-wrapper custom-switch-wrapper">
                            <label className="switch mb-0">
                              <input
                                type="checkbox"
                                checked={getValue(
                                  configRequest,
                                  `enabled_annexure_1`,
                                  false,
                                )}
                                onChange={() => {
                                  const newValue = !getValue(
                                    configRequest,
                                    `enabled_annexure_1`,
                                    false,
                                  );
                                  setConfigRequest({
                                    ...configRequest,
                                    enabled_annexure_1: newValue,
                                  });
                                }}
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    <InputField
                      inputType="TEXTAREA"
                      placeholder="Enter Annexure 1 No Data"
                      className="form-control w-100"
                      name="annexure_1_no_data"
                      id="annexure_1_no_data"
                      value={getValue(configRequest, `annexure_1_no_data`, "")}
                      onChange={(e: any) => handleChangeText(e)}
                      label="Annexure 1 No Data"
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex gap-2">
                  <div className="input-50">
                    <label className="checkpoint-active-details__label">
                      Annexure 2
                    </label>
                    <InputField
                      inputType="TEXTAREA"
                      placeholder="Enter Annexure 2"
                      className="form-control w-100"
                      name="annexure_2"
                      id="annexure_2"
                      value={getValue(configRequest, `annexure_2`, "")}
                      onChange={(e: any) => handleChangeText(e)}
                      label="Annexure 2"
                    />
                  </div>
                  <div className="input-50">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="checkpoint-active-details__label mb-0">
                        Annexure 2 If no Data
                      </label>

                      {!hideExtraAnnexures && (
                        <div className="d-flex align-items-center">
                          <p className="header_text__black mb-0 me-2">
                            Enable Annexure 2
                          </p>
                          <div className="choicelist-wrapper custom-switch-wrapper">
                            <label className="switch mb-0">
                              <input
                                type="checkbox"
                                checked={getValue(
                                  configRequest,
                                  `enabled_annexure_2`,
                                  false,
                                )}
                                onChange={() => {
                                  const newValue = !getValue(
                                    configRequest,
                                    `enabled_annexure_2`,
                                    false,
                                  );
                                  setConfigRequest({
                                    ...configRequest,
                                    enabled_annexure_2: newValue,
                                  });
                                }}
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    <InputField
                      inputType="TEXTAREA"
                      placeholder="Enter Annexure 2 No Data"
                      className="form-control w-100"
                      name="annexure_2_no_data"
                      id="annexure_2_no_data"
                      value={getValue(configRequest, `annexure_2_no_data`, "")}
                      onChange={(e: any) => handleChangeText(e)}
                      label="Annexure 2 No Data"
                    />
                  </div>
                </div>
              </div>

              {!hideExtraAnnexures && (
                <div className="mb-3">
                  <div className="d-flex gap-2">
                    <div className="input-50">
                      <label className="checkpoint-active-details__label">
                        Annexure 3
                      </label>
                      <InputField
                        inputType="TEXTAREA"
                        placeholder="Enter Annexure 3"
                        className="form-control w-100"
                        name="annexure_3"
                        id="annexure_3"
                        value={getValue(configRequest, `annexure_3`, "")}
                        onChange={(e: any) => handleChangeText(e)}
                        label="Annexure 3"
                      />
                    </div>

                    <div className="input-50">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <label className="checkpoint-active-details__label mb-0">
                          Annexure 3 If no Data
                        </label>

                        <div className="d-flex align-items-center">
                          <p className="header_text__black mb-0 me-2">
                            Enable Annexure 3
                          </p>
                          <div className="choicelist-wrapper custom-switch-wrapper">
                            <label className="switch mb-0">
                              <input
                                type="checkbox"
                                checked={getValue(
                                  configRequest,
                                  `enabled_annexure_3`,
                                  false,
                                )}
                                onChange={() => {
                                  const newValue = !getValue(
                                    configRequest,
                                    `enabled_annexure_3`,
                                    false,
                                  );
                                  setConfigRequest({
                                    ...configRequest,
                                    enabled_annexure_3: newValue,
                                  });
                                }}
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <InputField
                        inputType="TEXTAREA"
                        placeholder="Enter Annexure 3 No Data"
                        className="form-control w-100"
                        name="annexure_3_no_data"
                        id="annexure_3_no_data"
                        value={getValue(
                          configRequest,
                          `annexure_3_no_data`,
                          "",
                        )}
                        onChange={(e: any) => handleChangeText(e)}
                        label="Annexure 3 No Data"
                      />
                    </div>
                  </div>
                </div>
              )}

              {!hideExtraAnnexures && (
                <div className="mb-3">
                  <div className="d-flex gap-2">
                    <div className="input-50">
                      <label className="checkpoint-active-details__label">
                        Annexure 4
                      </label>
                      <InputField
                        inputType="TEXTAREA"
                        placeholder="Enter Annexure 4"
                        className="form-control w-100"
                        name="annexure_4"
                        id="annexure_4"
                        value={getValue(configRequest, `annexure_4`, "")}
                        onChange={(e: any) => handleChangeText(e)}
                        label="Annexure 4"
                      />
                    </div>

                    <div className="input-50">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <label className="checkpoint-active-details__label mb-0">
                          Annexure 4 If no Data
                        </label>

                        <div className="d-flex align-items-center">
                          <p className="header_text__black mb-0 me-2">
                            Enable Annexure 4
                          </p>
                          <div className="choicelist-wrapper custom-switch-wrapper">
                            <label className="switch mb-0">
                              <input
                                type="checkbox"
                                checked={getValue(
                                  configRequest,
                                  `enabled_annexure_4`,
                                  false,
                                )}
                                onChange={() => {
                                  const newValue = !getValue(
                                    configRequest,
                                    `enabled_annexure_4`,
                                    false,
                                  );
                                  setConfigRequest({
                                    ...configRequest,
                                    enabled_annexure_4: newValue,
                                  });
                                }}
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <InputField
                        inputType="TEXTAREA"
                        placeholder="Enter Annexure 4 No Data"
                        className="form-control w-100"
                        name="annexure_4_no_data"
                        id="annexure_4_no_data"
                        value={getValue(
                          configRequest,
                          `annexure_4_no_data`,
                          "",
                        )}
                        onChange={(e: any) => handleChangeText(e)}
                        label="Annexure 4 No Data"
                      />
                    </div>
                  </div>
                </div>
              )}

              {!hideExtraAnnexures && (
                <div className="mb-3">
                  <div className="d-flex gap-2">
                    <div className="input-50">
                      <label className="checkpoint-active-details__label">
                        Annexure 5
                      </label>
                      <InputField
                        inputType="TEXTAREA"
                        placeholder="Enter Annexure 5"
                        className="form-control w-100"
                        name="annexure_5"
                        id="annexure_5"
                        value={getValue(configRequest, `annexure_5`, "")}
                        onChange={(e: any) => handleChangeText(e)}
                        label="Annexure 5"
                      />
                    </div>

                    <div className="input-50">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <label className="checkpoint-active-details__label mb-0">
                          Annexure 5 If no Data
                        </label>

                        <div className="d-flex align-items-center">
                          <p className="header_text__black mb-0 me-2">
                            Enable Annexure 5
                          </p>
                          <div className="choicelist-wrapper custom-switch-wrapper">
                            <label className="switch mb-0">
                              <input
                                type="checkbox"
                                checked={getValue(
                                  configRequest,
                                  `enabled_annexure_5`,
                                  false,
                                )}
                                onChange={() => {
                                  const newValue = !getValue(
                                    configRequest,
                                    `enabled_annexure_5`,
                                    false,
                                  );
                                  setConfigRequest({
                                    ...configRequest,
                                    enabled_annexure_5: newValue,
                                  });
                                }}
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <InputField
                        inputType="TEXTAREA"
                        placeholder="Enter Annexure 5 No Data"
                        className="form-control w-100"
                        name="annexure_5_no_data"
                        id="annexure_5_no_data"
                        value={getValue(
                          configRequest,
                          `annexure_5_no_data`,
                          "",
                        )}
                        onChange={(e: any) => handleChangeText(e)}
                        label="Annexure 5 No Data"
                      />
                    </div>
                  </div>
                </div>
              )}

              {!hideExtraAnnexures && (
                <div className="d-flex align-items-start">
                  <div className="mb-3">
                    <div className="d-flex flex-column mx-2">
                      <p
                        className="header_text__black mb-2 me-2"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Legislation Rule Custom Date
                      </p>
                      <div className="choicelist-wrapper custom-switch-wrapper">
                        <label className="switch mb-0">
                          <input
                            type="checkbox"
                            checked={getValue(
                              configRequest,
                              `legislation_Rule_Custom_Date`,
                              false,
                            )}
                            onChange={() => {
                              const newValue = !getValue(
                                configRequest,
                                `legislation_Rule_Custom_Date`,
                                false,
                              );
                              const newValue2 = getValue(
                                configRequest,
                                `show_all_time_legislation_rule`,
                                false,
                              );
                              setConfigRequest({
                                ...configRequest,
                                legislation_Rule_Custom_Date: newValue,
                                show_all_time_legislation_rule:
                                  newValue && newValue2
                                    ? !newValue2
                                    : configRequest.show_all_time_legislation_rule,
                              });
                            }}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="d-flex flex-column mx-2">
                      <p
                        className="header_text__black mb-2 me-2"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Show All Time Legislation Rule
                      </p>
                      <div className="choicelist-wrapper custom-switch-wrapper">
                        <label className="switch mb-0">
                          <input
                            type="checkbox"
                            checked={getValue(
                              configRequest,
                              `show_all_time_legislation_rule`,
                              false,
                            )}
                            onChange={() => {
                              const newValue = !getValue(
                                configRequest,
                                `show_all_time_legislation_rule`,
                                false,
                              );
                              // for comment
                              const newValue2 = getValue(
                                configRequest,
                                `legislation_Rule_Custom_Date`,
                                false,
                              );
                              setConfigRequest({
                                ...configRequest,
                                show_all_time_legislation_rule: newValue,
                                legislation_Rule_Custom_Date:
                                  newValue && newValue2
                                    ? !newValue2
                                    : configRequest.legislation_Rule_Custom_Date,
                                contract_date: newValue ? configRequest.contract_date : null,
                              });
                            }}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  {getValue(configRequest, "show_all_time_legislation_rule", false) && (
                    <div className="contract-date-picker-wrapper mb-3 mx-2">
                      <p className="header_text__black mb-2">
                        Contract Date <span className="text-danger">*</span>
                      </p>
                      <InputField
                        inputType="DATETYPE-DOB"
                        className="form-control w-100"
                        value={
                          getValue(configRequest, "contract_date", null)
                            ? new Date(getValue(configRequest, "contract_date", null))
                            : null
                        }
                        placeholderText="Select Contract Date"
                        onChange={(e: any) => {
                          setConfigRequest({
                            ...configRequest,
                            contract_date: e ? convertDate(e) : null,
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="compelte-task-wrapper__cta d-flex align-items-center">
              <button
                className="ascent-button ascent-button--primary"
                onClick={() => setShowUpdatePopup(false)}
              >
                Close
              </button>
              <button
                className="ascent-button ascent-button--secondary"
                onClick={() => handleSubmit()}
                disabled={submitLoading}
              >
                {submitLoading
                  ? "Please wait..."
                  : editId
                    ? "Update"
                    : "Create"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CertificateConfig;
